import Model from "@/features/training/model/model";

class ARMarker extends Model {
    name;
    id;

    constructor(props) {
        super(props);
        this.name = props.name;
        this.id = props.resourceId;
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }

        const loadMarker = async () => {
            const markerModel = await ARMarkerManager.createNewARMarkerAsCADModel({
                id: this.id,
                name: this.name,
            });
        }

        console.log('Loading marker: ', this.name);
        if (getModelObject(this.id)) {
            removeModelFromScene(this.id);
        }

        await loadMarker();

        for (; ;) {
            if (!getModelObject(this.id)) {
                await sleep(1000);
                continue;
            }

            onLoadCallback(1);

            const model = modelManager.getModelById(this.id);

            processVisibilityMessage(undefined, this.id, SelectionActionApplyToType.Model, false, false);

            return;
        }
    }

    async setState(state, {patchState, appendState, staticPatchState}) {
        try {
            if (!getModelObject(this.id)) {
                return;
            }
            
            super.setState(state, {patchState, appendState, staticPatchState});
        } catch (err) {
            console.error(err);
        }

        const matrix = new THREE.Matrix4().compose(
            (new THREE.Vector3(...(state.position || [0, 0, 0]))),
            (new THREE.Quaternion(...(state.quaternion || [0, 0, 0, 1]))),
            (new THREE.Vector3(...(state.scale || [1, 1, 1])))
        );

        if (!window.noserver) {
            const args = text_loadARMarkerInMeeting + text_seperator + this.id + ":" + this.name + ":" + (state.visible ? 1 : 0) + ":" + matrix.elements;
            wv.sendTextMessage(args);
        }
    }

    getDefaultState() {
        const defaultState = super.getDefaultState();
        defaultState.type = ModelTypeEnum.AR_MARKER;
        return defaultState;
    }
}

export default ARMarker;